import React, { useState, useEffect } from "react";
import DietDetails from "./ReassessmentFormComponents/DietDetails";
import { Divider } from "antd";
import NutritionalRiskFactors from "./ReassessmentFormComponents/NutritionalRiskFactors";
import ContinuedNutritionalRisk from "./ReassessmentFormComponents/ContinuedNutritionalRisk";
import dayjs from "dayjs";
const ReassessmentForm = ({ form, formData }) => {
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    form?.setFieldsValue({
      ...formData,
      observed_date:
        formData?.observed_date && dayjs(formData?.observed_date ?? null),
    });
    setTimeout(() => setRefresh((prev) => !prev), 1000);
  }, [formData]);
  return (
    <>
      <DietDetails />
      <Divider />
      <NutritionalRiskFactors />
      <Divider />
      <ContinuedNutritionalRisk />
    </>
  );
};

export default ReassessmentForm;
